'use strict';
import React from 'react';
import classnames from 'classnames';
import style from './index.module.less';

export default function Divider(props) {
    const {noLine} = props;
    const cls = classnames({
        [style.divider]:true,
        [style.noLine]:noLine
    });

    return  <div className={cls}></div>;
}



// WEBPACK FOOTER //
// ./src/components/Divider/index.js